jQuery(document).ready(function(){
	jQuery('.home-products-brands .item-wrap').click(function(){
		jQuery('.home-products-brands .list-brands').find(".active").removeClass('active');
		jQuery(this).addClass('active');
		var data_tab = jQuery(this).attr('data-tab');
		console.log(data_tab);
		jQuery('.home-products-brands .list-products').find(".active").removeClass('active');
		jQuery('.'+data_tab).addClass('active');
	});
});